import { render, staticRenderFns } from "./MediaTranscript.vue?vue&type=template&id=8cb8e948&scoped=true"
import script from "./MediaTranscript.vue?vue&type=script&lang=js"
export * from "./MediaTranscript.vue?vue&type=script&lang=js"
import style0 from "./MediaTranscript.vue?vue&type=style&index=0&id=8cb8e948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb8e948",
  null
  
)

export default component.exports